<template>
  <div class="bnf-flight-only-price">
    <!------ plainform area start ------->
    <section class="plainform-area">
      <div class="container">
        <div class="plainformbox bnf-pax-card">
          <h3 class="bnf-pax-heading">פרטי נוסעים</h3>
          <div class="counter bnf-pax-row">
            <span class="bnf-pax-label">{{ $t("search-tab.adult") }}</span>
            <div class="bnf-pax-stepper">
              <button type="button" class="btn-count bnf-pax-btn" @click="changePaxes('adult', 'subtract')" :disabled="countAdult <= 1" aria-label="הפחת מבוגר">−</button>
              <input type="text" class="form-control bnf-pax-value" v-model="countAdult" @change="changePaxCount" readonly/>
              <button type="button" class="btn-count bnf-pax-btn" @click="changePaxes('adult', 'plus')" aria-label="הוסף מבוגר">+</button>
            </div>
          </div>
          <div class="counter bnf-pax-row">
            <span class="bnf-pax-label">{{ $t("search-tab.child") }}</span>
            <div class="bnf-pax-stepper">
              <button type="button" class="btn-count bnf-pax-btn" @click="changePaxes('child', 'subtract')" :disabled="countChild <= 0" aria-label="הפחת ילד">−</button>
              <input type="text" class="form-control bnf-pax-value" v-model="countChild" @change="changePaxCount" readonly/>
              <button type="button" class="btn-count bnf-pax-btn" @click="changePaxes('child', 'plus')" aria-label="הוסף ילד">+</button>
            </div>
          </div>
          <div class="counter bnf-pax-row">
            <span class="bnf-pax-label">{{ $t("product-page.infant") }}</span>
            <div class="bnf-pax-stepper">
              <button type="button" class="btn-count bnf-pax-btn" @click="changePaxes('infant', 'subtract')" :disabled="countInfant <= 0" aria-label="הפחת תינוק">−</button>
              <input type="text" class="form-control bnf-pax-value" v-model="countInfant" @change="changePaxCount" readonly/>
              <button type="button" class="btn-count bnf-pax-btn" @click="changePaxes('infant', 'plus')" aria-label="הוסף תינוק">+</button>
            </div>
          </div>
        </div>
        <div class="btn-group bnf-hide-redundant-cta">
          <button class="btn-primary">סה“כ לתשלום</button>
        </div>
      </div>
    </section>
    <!------ plainform area stop ------->
    <!----- order area start ----->
    <section class="order-area" v-if="device==='desktop'">
      <div class="container">
        <div class="order-list d-flex">
          <ul>
            <li>
              {{ $t('product-page.total-per-passenger') }}
              <strong>{{getPriceWithSymbol(currencySymbol, average)}}</strong>
            </li>
            <li>
              {{ $t("flight-only.total-to-pay") }}
              <strong>{{getPriceWithSymbol(currencySymbol, total)}}</strong>
            </li>
          </ul>
          <button class="btn-primary order" @click="gotoBook" :disabled="disableBook">הזמן עכשיו</button>
        </div>
      </div>
    </section>
    <section class="order-area bnf-fo-totals-panel" v-else>
      <div class="container">
        <div class="order-list bnf-fo-totals-list">
          <ul>
            <li class="bnf-fo-row bnf-fo-secondary">
              <span class="bnf-fo-label">{{ $t('product-page.total-per-passenger') }}</span>
              <strong class="bnf-fo-value">{{getPriceWithSymbol(currencySymbol, average)}}</strong>
            </li>
            <li class="bnf-fo-row bnf-fo-primary">
              <span class="bnf-fo-label">{{ $t("flight-only.total-to-pay") }}</span>
              <strong class="bnf-fo-value">{{getPriceWithSymbol(currencySymbol, total)}}</strong>
            </li>
            <li class="bnf-fo-breakdown" v-if="showBreakdown">
              <i class="fas fa-info-circle" aria-hidden="true"></i>
              <span>{{ priceBreakdownParts.join(' + ') }}</span>
            </li>
          </ul>
        </div>
        <div class="btn-box bnf-fo-cta-wrap">
          <button class="btn-primary bnf-fo-cta-primary" @click="gotoBook" :disabled="disableBook">
            <span class="bnf-fo-cta-text">הזמן עכשיו</span>
            <i class="fas fa-arrow-left bnf-fo-cta-arrow" aria-hidden="true"></i>
          </button>
        </div>
      </div>
    </section>
    <!----- order area stop ----->
  </div>
</template>
<script>
import { mapGetters } from 'vuex';
import gMixin from '@/utils/mixins';

export default {
  components: {
  },
  props: {
    occupancy: {
      type: Object,
      default: null,
    },
    airlineNotConfirmed: {
      type: Boolean,
      default: false,
    },
    image: {
      type: String,
      default: '',
    },
    total: {
      type: Number,
      default: 0,
    },
    average: {
      type: Number,
      default: 0,
    },
    infoFlight: {
      type: Object,
      default: () => ({
        name: 'Blue Bird Air...',
        description: 'Lorem ipsum dolor sit amet,',
      }),
    },
    currencySymbol: {
      type: String,
      default: 'US',
    },
  },
  mixins: [gMixin],
  data() {
    return {
      query: '',
      totalPrice: 0,
    };
  },
  computed: {
    ...mapGetters({
      device: 'GET_DEVICE',
      activeFlightId: 'GET_FLIGHT_ID',
    }),
    countAdult: {
      get() {
        return this.$store.getters.GET_SEARCH_CONTENT.adult
          ? this.$store.getters.GET_SEARCH_CONTENT.adult
          : 0;
      },
      set(value) {
        this.$store.dispatch('SET_SEARCH_ITEM', ['adult', value]);
      },
    },
    countChild: {
      get() {
        return this.$store.getters.GET_SEARCH_CONTENT.child
          ? this.$store.getters.GET_SEARCH_CONTENT.child
          : 0;
      },
      set(value) {
        this.$store.dispatch('SET_SEARCH_ITEM', ['child', value]);
      },
    },
    countInfant: {
      get() {
        return this.$store.getters.GET_SEARCH_CONTENT.infant
          ? this.$store.getters.GET_SEARCH_CONTENT.infant
          : 0;
      },
      set(value) {
        this.$store.dispatch('SET_SEARCH_ITEM', ['infant', value]);
      },
    },
    disableBook() {
      return this.activeFlightId === '';
    },
    /* R5: per-passenger price breakdown for the totals chip */
    priceBreakdownParts() {
      if (!this.occupancy) return [];
      const parts = [];
      const adultCt = Number(this.countAdult || 0);
      const childCt = Number(this.countChild || 0);
      const infantCt = Number(this.countInfant || 0);
      const adultPrice = Number(this.occupancy.price || 0);
      const childPrice = Number(this.occupancy.priceChild || 0);
      const infantPrice = Number(this.occupancy.priceInf || 0);
      if (adultCt > 0 && adultPrice > 0) {
        parts.push(`${adultCt} × ${this.getPriceWithSymbol(this.currencySymbol, adultPrice)} ${adultCt === 1 ? 'מבוגר' : 'מבוגרים'}`);
      }
      if (childCt > 0 && childPrice > 0) {
        parts.push(`${childCt} × ${this.getPriceWithSymbol(this.currencySymbol, childPrice)} ${childCt === 1 ? 'ילד' : 'ילדים'}`);
      }
      if (infantCt > 0 && infantPrice > 0) {
        parts.push(`${infantCt} × ${this.getPriceWithSymbol(this.currencySymbol, infantPrice)} ${infantCt === 1 ? 'תינוק' : 'תינוקות'}`);
      }
      return parts;
    },
    showBreakdown() {
      return this.priceBreakdownParts.length >= 2 || (this.priceBreakdownParts.length >= 1 && Number(this.countInfant || 0) + Number(this.countChild || 0) > 0);
    },
  },
  created() {
    this.query = this.$route.query;
    this.countAdult = this.query.adult;
    this.countChild = this.query.child;
    this.countInfant = this.query.infant;
  },
  methods: {
    changePaxes(pKindPax, pKindChange) {
      const diff = pKindChange === 'plus' ? 1 : -1;
      switch (pKindPax) {
        case 'adult':
          this.countAdult = Number(this.countAdult) + diff;
          if (this.countAdult < 0) this.countAdult = 0;
          break;
        case 'child':
          this.countChild = Number(this.countChild) + diff;
          if (this.countChild < 0) this.countChild = 0;
          break;
        case 'infant':
          this.countInfant = Number(this.countInfant) + diff;
          if (this.countInfant < 0) this.countInfant = 0;
          break;
        default:
      }
      this.$emit('emitUpdatePax');
    },
    changePaxCount() {
      // console.log(this.countAdult, this.countChild, this.countInfant);
      this.$emit('emitUpdatePax');
    },
    gotoBook() {
      this.$emit('emitBook');
    },
  },
};
</script>

<style lang="less" scoped>
  .bonauf-desktop {
    .flight_box_three {
      .plainformbox {
        max-width: 40%;
      }
    }
    .order-area {
      position: fixed;
      bottom: 0px;
      width: 100%;
      background: #fff;
      z-index: 9;

      .order-list {
        li {
          font-family: 'ploniregularaaa';
          font-size: 28px;
          color: #000;

          strong {
            display: block;
            font-family: 'FbCoherentiSansBold';
            font-size: 30px;
          }
        }
      }

      .order {
        height: 50px;
        width: 160px;
        margin: auto;
      }
    }
  }
</style>

<style scoped>
.right_box {
  margin: auto;
  width: 50%;
}
.right_box div.form-group {
  padding: 2px;
  margin: auto;
}

@media (max-width: 476px) {
  .flight_box_three_body_two .right_box .d-flex {
    display: inline-block !important;
    padding: 0px;
  }
  .right_box > div.col-6 {
    padding: 2px;
  }
  .right_box div.form-group {
    padding: 0px;
    max-width: 100%;
  }
  .flight_only_body .flight_box_three .flight_box_three_body_two .right_box {
    width: 100%;
  }

  .flight_box_three_body_two .right_box h5 {
    font-size: 12px;
  }
  .flight_box_three_body_two .right_box h3 {
    font-size: 21px;
  }
}

/* ====================================================================== */
/* R5: Premium overhaul for flight-only price box (FlightBoxThreeChildApp) */
/* Mirrors the hotel-flight ProductPriceAreaApp pattern                    */
/* ====================================================================== */
.bnf-flight-only-price .bnf-pax-card {
  background: #ffffff;
  border: 1px solid #e3e9f1;
  border-radius: 14px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.05);
  padding: 18px 16px 14px;
  margin: 12px auto 16px;
  max-width: 480px;
  background-image: none;
}
.bnf-flight-only-price .bnf-pax-heading {
  font-size: 16px;
  font-weight: 700;
  color: #0e436b;
  margin: 0 0 12px;
  padding-bottom: 8px;
  border-bottom: 1px dashed #d8e3f0;
  text-align: center;
}
.bnf-flight-only-price .bnf-pax-row {
  display: flex !important;
  flex-direction: row !important;
  justify-content: space-between;
  align-items: center;
  padding: 8px 0;
  background: transparent;
  border: 0;
  margin: 0;
}
.bnf-flight-only-price .bnf-pax-label {
  font-size: 14px;
  font-weight: 600;
  color: #1c4e80;
  flex: 0 0 auto;
}
.bnf-flight-only-price .bnf-pax-stepper {
  display: inline-flex;
  align-items: center;
  background: transparent;
  border: 1px solid #cfd8e3;
  border-radius: 999px;
  padding: 3px;
  height: 38px;
  flex: 0 0 auto;
  gap: 0;
}
.bnf-flight-only-price .bnf-pax-btn.btn-count {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 30px;
  height: 30px;
  background: #ffffff;
  color: #0e436b;
  border: 1px solid #e3e9f1;
  border-radius: 50%;
  font-size: 16px;
  font-weight: 700;
  line-height: 1;
  padding: 0;
  margin: 0;
  cursor: pointer;
  transition: all 0.18s ease;
  box-shadow: none;
}
.bnf-flight-only-price .bnf-pax-btn.btn-count:hover:not(:disabled),
.bnf-flight-only-price .bnf-pax-btn.btn-count:focus:not(:disabled) {
  background: #1c7ed6;
  color: #ffffff;
  border-color: #1c7ed6;
  outline: none;
}
.bnf-flight-only-price .bnf-pax-btn.btn-count:active:not(:disabled) {
  transform: scale(0.95);
}
.bnf-flight-only-price .bnf-pax-btn.btn-count:disabled {
  opacity: 0.35;
  cursor: not-allowed;
}
.bnf-flight-only-price .bnf-pax-value.form-control {
  display: inline-flex !important;
  align-items: center;
  justify-content: center;
  width: 38px !important;
  max-width: 38px !important;
  min-width: 38px !important;
  height: auto !important;
  background: transparent !important;
  border: 0 !important;
  box-shadow: none !important;
  padding: 0 6px !important;
  font-size: 15px;
  font-weight: 700;
  color: #0e436b;
  background-image: none !important;
  text-align: center;
  caret-color: transparent;
  pointer-events: none;
}
/* Hide the redundant middle "סה"כ לתשלום" label-as-button */
.bnf-flight-only-price .bnf-hide-redundant-cta {
  display: none !important;
}

/* ===== Order area (mobile sticky-bottom totals + CTA) ===== */
.bnf-fo-totals-panel {
  background: transparent !important;
  margin: 16px auto !important;
  padding: 0 !important;
}
.bnf-fo-totals-panel .container {
  max-width: 480px;
  margin: 0 auto;
  background: linear-gradient(180deg, #ffffff 0%, #f7faff 100%);
  border: 1px solid #d8e3f0;
  border-radius: 14px;
  padding: 16px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.05);
}
.bnf-fo-totals-list {
  margin-bottom: 14px;
}
.bnf-fo-totals-list ul {
  list-style: none;
  margin: 0;
  padding: 0;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  gap: 12px;
}
.bnf-fo-row {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 2px;
  line-height: 1.2;
  margin: 0;
  padding: 0;
}
.bnf-fo-row .bnf-fo-label {
  font-size: 12px;
  color: #6c7a8c;
  font-weight: 500;
}
.bnf-fo-row .bnf-fo-value {
  font-weight: 700;
  color: #0e436b;
}
.bnf-fo-secondary .bnf-fo-value {
  font-size: 16px;
  color: #475569;
}
.bnf-fo-primary {
  align-items: flex-end;
}
.bnf-fo-primary .bnf-fo-value {
  font-size: 24px;
  color: #0e436b;
}

/* Per-passenger breakdown chip below the totals */
.bnf-fo-breakdown {
  list-style: none;
  margin: 8px 0 0 !important;
  padding: 5px 12px !important;
  display: inline-flex;
  align-items: center;
  gap: 7px;
  background: #eef6ff;
  border: 1px solid #cfe2ff;
  border-radius: 999px;
  font-size: 11.5px;
  font-weight: 500;
  color: #1c4e80;
  width: fit-content;
  align-self: flex-end;
  line-height: 1.35;
  flex-wrap: wrap;
  max-width: 100%;
}
.bnf-fo-breakdown i {
  font-size: 11px;
  color: #1c7ed6;
  flex-shrink: 0;
}
.bnf-fo-breakdown span {
  word-break: break-word;
}
/* Ensure ul allows the chip to flow on its own row */
.bnf-fo-totals-list ul {
  flex-wrap: wrap;
}

/* Primary CTA — brand-blue gradient with arrow */
.bnf-fo-cta-wrap {
  width: 100%;
  display: block;
}
.bnf-fo-cta-primary.btn-primary {
  display: inline-flex !important;
  align-items: center;
  justify-content: center;
  gap: 10px;
  width: 100%;
  padding: 14px 22px;
  background: linear-gradient(135deg, #0061ab 0%, #1c7ed6 100%) !important;
  background-image: linear-gradient(135deg, #0061ab 0%, #1c7ed6 100%) !important;
  color: #ffffff !important;
  border: none !important;
  border-radius: 12px;
  font-size: 17px;
  font-weight: 700;
  letter-spacing: 0.3px;
  min-height: 52px;
  box-shadow: 0 4px 14px rgba(0, 97, 171, 0.32);
  transition: transform 0.12s ease, box-shadow 0.18s ease, filter 0.18s ease;
  cursor: pointer;
}
.bnf-fo-cta-primary.btn-primary:hover:not(:disabled),
.bnf-fo-cta-primary.btn-primary:focus:not(:disabled) {
  box-shadow: 0 6px 20px rgba(0, 97, 171, 0.42);
  filter: brightness(1.05);
  outline: none;
}
.bnf-fo-cta-primary.btn-primary:active:not(:disabled) {
  transform: translateY(1px);
}
.bnf-fo-cta-primary.btn-primary:disabled {
  background: linear-gradient(135deg, #94a8c5 0%, #b6c6dd 100%) !important;
  background-image: linear-gradient(135deg, #94a8c5 0%, #b6c6dd 100%) !important;
  cursor: not-allowed;
  box-shadow: none;
  opacity: 1;
}
.bnf-fo-cta-arrow {
  font-size: 14px;
  transition: transform 0.2s ease;
}
.bnf-fo-cta-primary.btn-primary:hover .bnf-fo-cta-arrow {
  transform: translateX(-3px);
}

@media (max-width: 479px) {
  .bnf-flight-only-price .bnf-pax-card {
    padding: 14px 12px;
  }
  .bnf-fo-totals-panel .container {
    padding: 14px 12px;
  }
  .bnf-fo-primary .bnf-fo-value {
    font-size: 20px;
  }
  .bnf-fo-cta-primary.btn-primary {
    font-size: 16px;
    min-height: 48px;
    padding: 12px 18px;
  }
}
</style>
